import React from 'react';
import { Chip, ChipProps } from '@mui/material';
import { SageContactDetails, getSageLinkLabel, getSageLinkColor } from '../../types/sage';

interface SageLinkChipProps {
  sageDetails?: SageContactDetails;
  size?: ChipProps['size'];
}

export const SageLinkChip: React.FC<SageLinkChipProps> = ({ sageDetails, size = 'small' }) => {
  const label = getSageLinkLabel(sageDetails);
  const linkedColor = getSageLinkColor(sageDetails);

  return (
    <Chip
      label={label}
      size={size}
      sx={(theme) => ({
        backgroundColor: sageDetails?.isLinkedToSage
          ? `${linkedColor}.50`
          : sageDetails?.isSageReady ? 'warning.50' : 'grey.100',
        color: sageDetails?.isLinkedToSage
          ? `${linkedColor}.main`
          : sageDetails?.isSageReady ? 'warning.main' : 'text.secondary',
        fontWeight: 600,
        ...theme.applyStyles('dark', {
          backgroundColor: sageDetails?.isLinkedToSage
            ? `${linkedColor}.900`
            : sageDetails?.isSageReady ? 'warning.900' : 'grey.800',
        }),
      })}
    />
  );
};
